package com.futurions.portfolio.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.Img

@Composable
fun ProjectsSection() {
    // Outer Box — centers everything
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .padding(top = 80.px, bottom = 80.px)
    ) {
        // Inner Card — actual projects content
        Column(
            modifier = Modifier
                .maxWidth(1100.px)
                .fillMaxWidth()
                .backgroundColor(rgba(255, 255, 255, 0.08))
                .backdropFilter(blur(16.px))
                .borderRadius(24.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 4.px,
                    blurRadius = 25.px,
                    spreadRadius = 8.px,
                    color = rgba(0, 0, 0, 0.25)
                  //  0.px, 4.px, 25.px, rgba(0, 0, 0, 0.25)
                )
                .padding(48.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // --- Section Title ---
            SpanText(
                "🚀 Projects",
                modifier = Modifier
                    .fontSize(32.px)
                    .fontWeight(FontWeight.Bold)
                    .color(rgb(255, 255, 255))
                    .padding(bottom = 24.px)
            )

            // --- Project Grid ---
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .flexWrap(FlexWrap.Wrap)
                    .justifyContent(JustifyContent.Center)
                    .gap(24.px)
            ) {
                val projects = listOf(
                    Project("NutriSport", "Fitness tracking app using Google Fit & Firebase", "/images/nutri_sport.png"),
                    Project("Blinkit Clone", "Grocery delivery app using Kotlin + XML + ViewModel", "/images/quiz_special.png"),
                    Project("QuizTime", "Quiz app powered by Ktor backend & MongoDB", "/images/image_vista.png"),
                    Project("Smart Notes", "AI-powered notes & to-do app with Firebase", "/images/frame.png"),
                    Project("PDF Creator", "Adobe Scan-like app built with Jetpack Compose", "/images/bhagawad_gita_portfolio.png"),
                    Project("Anime World", "2D Anime City builder game in Unreal Engine", "https://via.placeholder.com/300"),
                    Project("Portfolio Site", "This portfolio made with Kobweb & Compose Web", "https://via.placeholder.com/300"),
                    Project("Live Stream App", "Full-screen live streaming app with chat", "https://via.placeholder.com/300")
                )

                projects.forEach { project ->
                  //  ProjectCard(project)
                    ProjectCard(
                        title = project.title,
                        description = project.description,
                        imageUrl = project.imageUrl
                    )
                }
            }
        }
    }
}


data class Project(
    val title: String,
    val description: String,
    val imageUrl: String,
    val githubUrl:String?=null,
    val icons: List<String> ?= null,
    val features: List<String>?=null,
    val playStoreLink: String?=null
)

@Composable
fun ProjectCard(project: Project) {
    Column(
        modifier = Modifier
            .width(300.px)
            .backgroundColor(rgba(255, 255, 255, 0.07))
            .borderRadius(16.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 20.px,
                spreadRadius = 8.px,
                color = rgba(0, 0, 0, 0.25)

             //   0.px, 4.px, 20.px, rgba(0, 0, 0, 0.25)
            )
            .transition(Transition.of("transform", 0.3.s))
            .padding(16.px)
    ) {
        Image(
            src = project.imageUrl,
            description = project.title,
            modifier = Modifier
                .fillMaxWidth()
                .height(260.px)
                .borderRadius(16.px)
                .objectFit(ObjectFit.Cover)
        )

        SpanText(
            project.title,
            modifier = Modifier
                .fontSize(20.px)
                .fontWeight(FontWeight.Bold)
                .color(rgb(255, 255, 255))
                .padding(bottom = 6.px)
        )

        SpanText(
            project.description,
            modifier = Modifier
                .fontSize(15.px)
                .color(rgb(210, 210, 210))
                .lineHeight(22.px)
        )
    }
}



@Composable
fun ProjectCard(
    title: String,
    description: String,
    imageUrl: String,
) {
    val colorMode = ColorMode.current
    Box(
    ) {
        Column(
            modifier = Modifier
                .width(100.percent)
                .fillMaxHeight()
                .padding(1.cssRem),
            horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Top
        ) {
            Img(
                src = imageUrl,
                attrs = Modifier
                    .width(100.percent)
                    .maxHeight(250.px)
                    .objectFit(ObjectFit.Cover)
                    .borderRadius(18.px)
                    .toAttrs()
            )

            SpanText(
                title,
                Modifier
                    .margin(top = 8.px)
                    .fontFamily("Share Tech Mono")
                    .fontWeight(FontWeight.Bold)
                    .color(Color.white)
            )

            SpanText(
                description,
                Modifier
                    .margin(top = 4.px)
                    .fontFamily("VT323")
                    .color(Color.white)
            )
            Spacer()


        }




    }
}
